import { Flex, Select, Text } from '@approvalmax/ui/src/components';
import { domain } from 'modules/data';
import { memo } from 'react';

import { useReportSchedulerContext } from '../../ReportSchedulerPopup.context';
import { SelectDay } from '../SelectDay/SelectDay';
import { SelectTime } from '../SelectTime/SelectTime';
import { options } from './CustomMonthlyScheduleOption.constants';
import { useDayOptionSelect, useMonthOptionSelect, useTimeOptionSelect } from './CustomMonthlyScheduleOption.hooks';
import { messages } from './CustomMonthlyScheduleOption.messages';
import { CustomMonthlyScheduleOptionProps } from './CustomMonthlyScheduleOption.types';

export const CustomMonthlyScheduleOption = memo<CustomMonthlyScheduleOptionProps>((props) => {
    const { ruleIndex } = props;

    const { schedule } = useReportSchedulerContext();

    const ruleConfig = schedule.rules[ruleIndex].configuration;
    const isCustomDay = ruleConfig.monthlyOptions === domain.MonthlyOption.CustomDay;

    const lastMonthlyRepeatableDay = 28;

    const { value: valueMonth, handleChange: handleChangeMonth } = useMonthOptionSelect(ruleIndex);
    const { value: valueDay, handleChange: handleChangeDay } = useDayOptionSelect(ruleIndex);
    const { value: valueTime, handleChange: handleChangeTime } = useTimeOptionSelect(ruleIndex);

    return (
        <Flex
            size={isCustomDay ? 24 : 12}
            alignItems='center'
            spacing='8'
            wrap={false}
            data-qa='custom-monthly-schedule'
        >
            <Text font='label' color='midnight70' fontSize='small'>
                {messages.everyText}
            </Text>

            <Flex block grow={1} shrink={0}>
                <Select
                    size='small'
                    clearable={false}
                    items={options}
                    itemIdKey='id'
                    itemNameKey='text'
                    qa='month-day'
                    value={valueMonth}
                    onChange={handleChangeMonth}
                />
            </Flex>

            {isCustomDay && (
                <>
                    <Text font='label' color='midnight70' fontSize='small'>
                        {messages.onDay}
                    </Text>

                    <Flex block grow={1} shrink={0}>
                        <SelectDay daysAmount={lastMonthlyRepeatableDay} day={valueDay} onChange={handleChangeDay} />
                    </Flex>
                </>
            )}

            <Text font='label' color='midnight70' fontSize='small'>
                {messages.timeLabel}
            </Text>

            <SelectTime time={valueTime} onChange={handleChangeTime} />
        </Flex>
    );
});

CustomMonthlyScheduleOption.displayName = 'CustomMonthlyScheduleOption';
